module.exports = __webpack_public_path__ + "static/img/fam.4d8c772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/fam.png
// module id = X1wJ
// module chunks = 0